<body
  class="layout nb-layout vertical-layout vertical-menu-modern 1-column  navbar-floating footer-static bg-full-screen-image  blank-page blank-page"
  data-open="click" data-menu="vertical-menu-modern" data-col="1-column">
  <!-- BEGIN: Content-->
  <div class="app-content content" style="height:80vh;">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>

      <div class="content-body" style="margin-left:0px;">
        <section class="row flexbox-container">
          <div class="col-xl-1"></div>
          <div class="col-xl-10 col-lg-12 col-12 d-flex justify-content-center px-0" style="margin-top: 30vh;">
            <div class="col-lg-4 col-md-2 col-0"></div>

            <div class="card col-lg-4 col-md-8 col-12">
              <div class="row">

                <div class="col-lg-12 col-12 p-0">
                  <div class="card rounded-0">
                    <div class="card-header pb-2 headerbg">
                      <div class="nb-header">
                        <h6 class="mb-0 titletxt">Reset password</h6>
                      </div>
                    </div>
                    <p class="notetxt px-4 pt-2 pb-0 mb-0">Your password must have atleast one lowercase,uppercase,number and special character.</p>
                    <div class="card-content">
                      <div class="card-body pt-1 mt-0">
                        <form [formGroup]="resetForm" class="login-container" (ngSubmit)="onSubmitResetPw()">
                          <div class="form-group">
                            <nb-form-field>
                              <input type="password" nbInput fullWidth placeholder="New Password" fieldSize="medium"
                                formControlName="newPassword" [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }"
                                name="newPassword" class="forgotInput" />
                            </nb-form-field>
                            <div *ngIf="submitted && f.newPassword.errors" class="errorMessage">
                              <div *ngIf="f.newPassword.errors.required">New password is required</div>
                              <div *ngIf="f.newPassword.errors.pattern">Password must have
                                atleast 8 characters including one
                                lowercase,uppercase,number and special character</div>
                            </div>
                          </div>

                          <div class="form-group">
                            <nb-form-field>
                              <input type="password" nbInput fullWidth placeholder="Confirm Password" fieldSize="medium"
                                formControlName="confirmPassword"
                                [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" class="forgotInput" />
                            </nb-form-field>
                            <div *ngIf="submitted && f.confirmPassword.errors" class="errorMessage">
                              <div *ngIf="f.confirmPassword.errors.required">Confirm password is required</div>
                              <div *ngIf="f.confirmPassword.errors.mustMatch">Please enter the same password</div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="float-md-left mb-1 col-md-6 col-6">
                              <button (click)="backToLogin()" class="btn btn-primary back-btn btn-inline">Back
                                to Login</button>
                            </div>
                            <div class="float-md-right mb-1  col-md-6 col-6">
                              <!-- <a href="#" class="btn btn-primary btn-block px-75 waves-effect waves-light">Recover Password</a> -->
                              <button id='submitReset' class="btn custom-btn float-right btn-inline" [class.disabledBtn]="loading"><nb-icon nbPrefix class="fa fa-spinner fa-spin" pack="font-awesome"></nb-icon>Reset Password</button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="login-footer">
                      <div class="divider">
                        <!-- <div class="divider-text">OR</div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-2  col-0"></div>
          </div>
          <div class="col-xl-1"></div>
        </section>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</body>
